import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = () => {
  const roles = [
    {
      id: 'retail',
      icon: 'User',
      title: 'Retail User',
      description: 'Personal finance management and budgeting',
      credentials: 'retail@finvisar.com'
    },
    {
      id: 'enterprise',
      icon: 'Building2',
      title: 'Enterprise Client',
      description: 'Corporate financial wellness programs',
      credentials: 'enterprise@finvisar.com'
    },
    {
      id: 'partner',
      icon: 'Store',
      title: 'Retail Partner',
      description: 'Merchant portal and analytics',
      credentials: 'partner@finvisar.com'
    },
    {
      id: 'admin',
      icon: 'Shield',
      title: 'Super Administrator',
      description: 'Platform management and oversight',
      credentials: 'admin@finvisar.com'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">Select Your Account Type</h3>
        <p className="text-xs md:text-sm text-muted-foreground">Choose the role that matches your access level</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {roles?.map((role) => (
          <div
            key={role?.id}
            className="p-4 md:p-5 border-2 border-border rounded-xl hover:border-primary hover:bg-primary/5 transition-smooth cursor-pointer group"
          >
            <div className="flex items-start gap-3 md:gap-4">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 group-hover:bg-primary/20 flex items-center justify-center transition-smooth">
                <Icon name={role?.icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">{role?.title}</h4>
                <p className="text-xs md:text-sm text-muted-foreground mb-2">{role?.description}</p>
                <p className="text-xs text-primary font-medium">{role?.credentials}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-3 md:p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            All demo accounts use the password format: <span className="font-medium text-foreground">RoleName@2026</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleSelector;